import { useEffect, useState } from "react";

/**
 * Follows a flag, but only after it has stayed true for `delayMs`. Turning off is immediate.
 *
 * The gallery uses it so a load that answers quickly never flashes skeletons: the placeholders appear
 * only once the wait is long enough for the reader to notice it.
 */
export default function useDelayedFlag(isOn: boolean, delayMs: number): boolean {
  const [stateIsOnForLongEnough, setStateIsOnForLongEnough] = useState(false);

  useEffect(() => {
    if (!isOn) {
      setStateIsOnForLongEnough(false);
      return undefined;
    }

    const timer = setTimeout(() => setStateIsOnForLongEnough(true), delayMs);
    return () => clearTimeout(timer);
  }, [isOn, delayMs]);

  return isOn && stateIsOnForLongEnough;
}
